 /* eslint-disable */ 
import { useRef, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { CSVLink } from "react-csv";
// material
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText } from '@mui/material';
import { deleteForm } from '../../../stores/actions/form';
import BootStrapDialog from '../../../components/Dialog'
// component
import Iconify from '../../../components/Iconify';


// ----------------------------------------------------------------------

export default function UserMoreMenu({ records, id, species, aggregated, isSpeciesSpecific }) {


  const dispatch = useDispatch()
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete =() => {
    dispatch(deleteForm(id))
  }

  const [ebirdExport, setEbirdExport] = useState({
    location: '',
    country: '',
    province: '',
    distance: '',
    area: '',
    comments: '',
  })


  const speciesComments = "Species Comments"
  const commonName = "Common Name"
  const locationName = "Location Name"
  const startTime = "Start Time"
  const province = "State/Province"
  const country = "Country Code"
  const numberOfObservers = "Number of Observers"
  const allObserved = "All observations reported?"
  const distance = "Effort Distance Miles"
  const area = "Effort area acres"
  const comments = "Submission Comments"

const exportToEbird = records.map((record) => {
  return{
    [`${commonName}`]: record.englishName, 
    Genus: '',
    Species: '',
    Number: record.count,
    [`${speciesComments}`]: '',
    [`${locationName}`]: ebirdExport.location,
    Latitude: record.latitude, 
    Longitude: record.longitude,
    Date: record.date,
    [`${startTime}`]: record.time,
    [`${province}`]: ebirdExport.province,
    [`${country}`]: ebirdExport.country,
    Protocol: 'Traveling',
    [`${numberOfObservers}`]: 1,
    Duration: 60,
    [`${allObserved}`]: "Y",
    [`${distance}`]: ebirdExport.distance,
    [`${area}`]: ebirdExport.area,
    [`${comments}`]: ebirdExport.comments,


  }
})


  
  const exportToBirdLasser = records.map((record) => {
    return {
      SPECIES_NAME_ENG: record.englishName ? record.englishName : record.commonName, 
      TRIPCARD: record.title, 
      LATITUDE: record.latitude, 
      LONGITUDE: record.longitude, 
      DATE_TIME: `${record.date}T${record.time}`,
      TIMEZONE: 120,
      SEEN: true,
      LIFER: true,
      COUNT: record.count
      }
  })


  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
    <BootStrapDialog 
        open={open} 
        setOpen={setOpen} 
        ebirdExport={ebirdExport} 
        setEbirdExport={setEbirdExport} 
        handleClose={handleClose} 
        exportToEbird={exportToEbird}
      />
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Iconify icon="eva:more-vertical-fill" width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' },
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >

    <CSVLink
        data={records}
        filename={"datasheet.csv"}
        className="btn btn-primary"
        target="_blank"
        style={{textDecoration: 'none'}}
      >
        <MenuItem component={'button'} sx={{ color: 'text.secondary' }}>
          <ListItemIcon>
            <Iconify icon="eva:download-outline" width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Download Datasheet" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>
    </CSVLink>

    {/* {isSpeciesSpecific && (
        <CSVLink
        data={aggregated}
        filename={"aggregated-datasheet.csv"}
        className="btn btn-primary"
        target="_blank"
        style={{textDecoration: 'none'}}
      >
        <MenuItem component={'button'} sx={{ color: 'text.secondary' }}>
          <ListItemIcon>
            <Iconify icon="eva:download-outline" width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Export as Aggregate" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>
    </CSVLink>
      )} */}

    <CSVLink
        data={species}
        filename={"datasheet.csv"}
        className="btn btn-primary"
        target="_blank"
        style={{textDecoration: 'none'}}
      >
        <MenuItem component={'button'} sx={{ color: 'text.secondary' }}>
          <ListItemIcon>
            <Iconify icon="eva:download-outline" width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Download Species list" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>
    </CSVLink>

  
        <MenuItem component={'button'} sx={{ color: 'text.secondary' }} onClick={handleClickOpen}>
          <ListItemIcon>
            <Iconify icon="eva:download-outline" width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Export→eBird" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>
        

      </Menu>
    </>
  );
}
